import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { getUserData, checkPasswordResetRequested } from '../redux/slices/userSlice';
import { getUserRoleCategories } from '../helpers/roleAccessControl';
import { useOrderStatus } from '../hooks/useOrderStatus';

const useLoginRedirect = () => {
    const { user, initialLoginData } = useSelector((state) => state.user);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const username = searchParams.get('username');
    const { selectedAgreementID } = useOrderStatus();

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            dispatch(getUserData());
        }
    }, [dispatch]);

    useEffect(() => {
        if (username) {
            dispatch(checkPasswordResetRequested(username))
                .then((action) => {
                    if (action.payload && action.payload.PasswordResetRequested) {
                        navigate(`/login?username=${username}`);
                    } else {
                        navigate('/login');
                    }
                })
                .catch((error) => {
                    console.error('Error checking password reset status:', error);
                    navigate('/login');
                });
        } else if (user) {
            const userRoles = getUserRoleCategories(user.RoleIds);

            if (userRoles.includes('adUser') && userRoles.includes('admin')) {
                navigate('/admin');
            } else if (userRoles.includes('adUser')) {
                if (selectedAgreementID && selectedAgreementID !== 'null' && selectedAgreementID !== 'undefined') {
                    navigate(`/order-status/${selectedAgreementID}`);
                } else if (initialLoginData?.Agreements && initialLoginData.Agreements.length > 0) {
                    const firstAgreementID = initialLoginData.Agreements[0].AgreementID;
                    navigate(`/order-status/${firstAgreementID}`);
                } else {
                    navigate('/account');
                }
            } else if (userRoles.includes('gymUser')) {
                navigate('/content-overview');
            }
        } else {
            navigate('/login');
        }
    }, [user, navigate, dispatch, username, selectedAgreementID, initialLoginData]);

};

export default useLoginRedirect;